import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
  Fragment,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  checkArray,
  checkNull,
  changeDateFormat,
} from "../../../../../../helpers";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  changeSettingValue,
  getMasterSetting,
  refreshServicePeriodsMasterSetting,
  saveServicePeriodsMasterSetting,
  updateServicePeriodsMasterSetting,
  updateServicePeriodsMasterSettingStatus,
} from "../../../../../../Redux/actions";
import ModelContainer from "../../../../../Components/ModelContainer";
import ErrorContainer from "../../../../../Components/ErrorContainer";

const servicePeriodsMasterSettingSchema = yup.object({
  id: yup.string().nullable(),
  service_period_id: yup.string().required(),
  accounts: yup.array().nullable(),
});
const editServicePeriodMasterSettingSchema = yup.object({
  master_id: yup.string().required(),
  service_period_id: yup.string().required(),
  merchant_id: yup.string().required(),
  cluster_id: yup.string().required(),
  store_merchant_id: yup.string().required(),
});

const ServicePeriod = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    master_setting_details,
    servicePeriodsMasterSettingModal,
    is_servicePeriodsMasterSetting_loading,
    editServicePeriodsMasterSettingModal,
    is_editServicePeriodsMasterSetting_loading,
  } = useSelector((state) => state.settingReducer);

  useEffect(() => {
    dispatch(getMasterSetting());

    return () => {
      dispatch(changeSettingValue("master_setting_details", null));
    };
  }, []);

  /* ServicePeriodMasterSettings */
  const initialservicePeriodsMasterSettingForm = {
    id: "",
    service_period_id: "",
    accounts: [],
  };
  const {
    register: servicePeriodsMasterSettingReg,
    formState: { errors: servicePeriodsMasterSettingErrors },
    handleSubmit: servicePeriodsMasterSettingSubmit,
    setValue: servicePeriodsMasterSettingSetValue,
    reset: servicePeriodsMasterSettingReset,
  } = useForm({
    resolver: yupResolver(servicePeriodsMasterSettingSchema),
    defaultValues: initialservicePeriodsMasterSettingForm,
    mode: "all",
    reValidateMode: "onChange",
  });
  const [
    servicePeriodsMasterSettingInputForm,
    setServicePeriodMasterSettingInputForm,
  ] = useState(initialservicePeriodsMasterSettingForm);

  const [accounts, setAccounts] = useState([]);

  const changeServicePeriodMasterSettingInputHandler = (input, val) => {
    servicePeriodsMasterSettingSetValue(input, val);
    setServicePeriodMasterSettingInputForm((prevState) => ({
      ...prevState,
      [input]: val,
    }));
  };
  const initialServicePeriodMasterSettingModalState = (
    initailVal = initialservicePeriodsMasterSettingForm
  ) => {
    setServicePeriodMasterSettingInputForm(initailVal);
    servicePeriodsMasterSettingReset(initailVal);
  };
  const closeServicePeriodMasterSettingModal = useCallback(
    (value) => {
      dispatch(changeSettingValue("servicePeriodsMasterSettingModal", value));
      initialServicePeriodMasterSettingModalState();
    },
    [servicePeriodsMasterSettingModal]
  );
  const submitServicePeriodMasterSettingForm = (data) => {
    data.accounts = accounts;
    data.setting_type = 1;
    console.log("submitServicePeriodMasterSettingForm", data);
    dispatch(saveServicePeriodsMasterSetting(data));
  };
  const submitPmMasterUpdateSettingForm = (data) => {
    data.accounts = accounts;
    data.setting_type = 2;
    console.log("submitPmMasterUpdateSettingForm", data);
    dispatch(saveServicePeriodsMasterSetting(data));
  };
  const deleteServicePeriodMasterSettingHandler = (id) => {
    // dispatch(deleteServicePeriodMasterSetting({ id }));
  };

  /* Edit pm Master Setting */

  const initialeditServicePeriodMasterSettingForm = {
    master_id: "",
    service_period_id: "",
    merchant_id: "",
    cluster_id: "",
    store_merchant_id: "",
  };
  const {
    register: editServicePeriodMasterSettingReg,
    formState: { errors: editServicePeriodMasterSettingErrors },
    handleSubmit: editServicePeriodMasterSettingSubmit,
    setValue: editServicePeriodMasterSettingSetValue,
    reset: editServicePeriodMasterSettingReset,
  } = useForm({
    resolver: yupResolver(editServicePeriodMasterSettingSchema),
    defaultValues: initialeditServicePeriodMasterSettingForm,
    mode: "all",
    reValidateMode: "onChange",
  });
  const [selectedServicePeriodSetting, setSelectedServicePeriodSetting] =
    useState(null);
  const [
    editServicePeriodMasterSettingInputForm,
    setEditServicePeriodMasterSettingInputForm,
  ] = useState(initialeditServicePeriodMasterSettingForm);

  const changeEditServicePeriodMasterSettingInputHandler = (input, val) => {
    editServicePeriodMasterSettingSetValue(input, val);
    setEditServicePeriodMasterSettingInputForm((prevState) => ({
      ...prevState,
      [input]: val,
    }));
  };
  const initialEditServicePeriodMasterSettingModalState = (
    initailVal = initialeditServicePeriodMasterSettingForm
  ) => {
    setEditServicePeriodMasterSettingInputForm(initailVal);
    editServicePeriodMasterSettingReset(initailVal);
  };
  const closeEditServicePeriodMasterSettingModal = useCallback(
    (value) => {
      if (!value) setSelectedServicePeriodSetting(null);
      dispatch(
        changeSettingValue("editServicePeriodsMasterSettingModal", value)
      );
      initialEditServicePeriodMasterSettingModalState();
    },
    [editServicePeriodsMasterSettingModal]
  );
  const submitEditServicePeriodMasterSettingForm = (data) => {
    data.setting_type = 1;
    console.log("submitEditServicePeriodMasterSettingForm", data);
    dispatch(updateServicePeriodsMasterSetting(data));
  };
  const submitEditPmMasterUpdateSettingForm = (data) => {
    data.setting_type = 2;
    console.log("submitEditPmMasterUpdateSettingForm", data);
    dispatch(updateServicePeriodsMasterSetting(data));
  };
  const deleteEditServicePeriodMasterSettingHandler = (id) => {
    // dispatch(deleteEditServicePeriodMasterSetting({ id }));
  };

  const editServicePeriodMasterSettingHandler = (
    editServicePeriodMasterSetting
  ) => {
    setSelectedServicePeriodSetting(editServicePeriodMasterSetting);
    closeEditServicePeriodMasterSettingModal(true);
    const editValues = {
      master_id: editServicePeriodMasterSetting?.id ?? "",
      service_period_id:
        editServicePeriodMasterSetting?.service_period_id ?? "",
      merchant_id: editServicePeriodMasterSetting?.merchant_id ?? "",
      cluster_id: editServicePeriodMasterSetting?.cluster_id ?? "no",
      store_merchant_id:
        editServicePeriodMasterSetting?.store_merchant_id ?? "",
    };
    initialEditServicePeriodMasterSettingModalState(editValues);
  };

  /* Edit pm Master Setting END */

  const updateServicePeriodSettingStatusHandler = (id, status) => {
    dispatch(updateServicePeriodsMasterSettingStatus({ id, status }));
  };
  const refreshServicePeriodsMasterSettingHandler = (id) => {
    dispatch(refreshServicePeriodsMasterSetting({ id }));
  };

  const getServicePeriodMasterSettingAction = (servicePeriodsMasterSetting) => {
    let res = null;
    if (servicePeriodsMasterSetting?.status == 1) {
      res = (
        <>
          {servicePeriodsMasterSetting?.setting_type == 1 ? (
            <a
              role="button"
              class="circle_icon edit_tooltip editAccountPm"
              onClick={() =>
                editServicePeriodMasterSettingHandler(
                  servicePeriodsMasterSetting
                )
              }
            >
              <i class="iconSprites edit-icon"></i>
            </a>
          ) : (
            <a
              role="button"
              class="circle_icon refresh_tooltip refresh_setting_pm"
              onClick={() =>
                refreshServicePeriodsMasterSettingHandler(
                  servicePeriodsMasterSetting?.id
                )
              }
            >
              <i class="iconSprites refresh-icon"></i>
            </a>
          )}

          <a
            role="button"
            class="circle_icon pwr_tooltip on"
            onClick={() =>
              updateServicePeriodSettingStatusHandler(
                servicePeriodsMasterSetting?.id,
                "inactive"
              )
            }
          >
            <i class="iconSprites pwr-icon"></i>
          </a>
        </>
      );
    } else {
      res = (
        <a
          role="button"
          class="circle_icon pwr_tooltip"
          onClick={() =>
            updateServicePeriodSettingStatusHandler(
              servicePeriodsMasterSetting?.id,
              "active"
            )
          }
        >
          <i class="iconSprites pwr-icon"></i>
        </a>
      );
    }
    return res;
  };

  const checkAccountIsClicked = (account) => {
    let res = true;

    if (
      checkArray(accounts) &&
      checkArray(account?.cluster) &&
      checkArray(account?.cluster.filter((p) => checkArray(p.stores)))
    ) {
      let accountIds = [];
      account?.cluster
        .filter((p) => checkArray(p.stores))
        .map((cluster) => {
          if (checkArray(cluster?.stores)) {
            cluster?.stores.map((store) => {
              accountIds.push(store.merchant_id);
            });
          }
        });
      let allSelectedStoreId = [];
      if (checkArray(accounts)) {
        accounts.map((acc) => {
          allSelectedStoreId.push(acc.store_merchant_id);
        });
      }
      return accountIds.every((ai) => allSelectedStoreId.includes(ai));
    } else {
      res = false;
    }
    return res;
  };

  const checkClusterIsClicked = (cluster) => {
    let res = true;
    if (checkArray(accounts) && checkArray(cluster?.stores)) {
      let clusterIds = [];
      cluster?.stores.map((store) => {
        clusterIds.push(store.merchant_id);
      });
      let allSelectedStoreId = [];
      if (checkArray(accounts)) {
        accounts.map((acc) => {
          allSelectedStoreId.push(acc.store_merchant_id);
        });
      }
      return clusterIds.every((ai) => allSelectedStoreId.includes(ai));
    } else {
      res = false;
    }
    return res;
  };

  const otherAccountClickHandler = (other_account) => {
    let newAccounts = [...accounts];
    if (
      newAccounts.findIndex((p) => p.store_merchant_id == other_account?.id) >
      -1
    ) {
      newAccounts = newAccounts.filter(
        (p) => p.store_merchant_id != other_account?.id
      );
    } else {
      newAccounts.push({
        merchant_id: other_account?.parent_merchant_id,
        cluster_id: other_account?.id,
        store_merchant_id: other_account?.id,
      });
    }
    setAccounts(newAccounts);
  };
  const accountClickHandler = (account) => {
    let newAccounts = [...accounts];
    newAccounts = newAccounts.filter((p) => p.merchant_id != account?.id);
    const checkIsClicked = checkAccountIsClicked(account);
    if (checkArray(account?.cluster) && !checkIsClicked) {
      account?.cluster
        .filter((p) => checkArray(p.stores))
        .map((cluster) => {
          if (checkArray(cluster?.stores)) {
            cluster?.stores.map((store) => {
              newAccounts.push({
                merchant_id: account?.id,
                cluster_id: store?.cluster_id,
                store_merchant_id: store?.merchant_id,
              });
            });
          }
        });
    }
    setAccounts(newAccounts);
  };

  const clusterClickHandler = (merchantId, cluster) => {
    let newAccounts = [...accounts];
    newAccounts = newAccounts.filter((p) => p.cluster_id != cluster?.id);
    const checkIsClicked = checkClusterIsClicked(cluster);
    if (checkArray(cluster?.stores) && !checkIsClicked) {
      cluster?.stores.map((store) => {
        newAccounts.push({
          merchant_id: merchantId,
          cluster_id: store?.cluster_id,
          store_merchant_id: store?.merchant_id,
        });
      });
    }
    setAccounts(newAccounts);
  };

  const storeClickHandler = (merchantId, store) => {
    let newAccounts = [...accounts];
    if (
      newAccounts.findIndex((p) => p.store_merchant_id == store?.merchant_id) >
      -1
    ) {
      newAccounts = newAccounts.filter(
        (p) => p.store_merchant_id != store?.merchant_id
      );
    } else {
      newAccounts.push({
        merchant_id: merchantId,
        cluster_id: store?.cluster_id,
        store_merchant_id: store?.merchant_id,
      });
    }
    setAccounts(newAccounts);
  };

  const msetingArr = {
    1: "Master & Lock",
    2: "Push & Forgot",
  };

  return (
    <div className="accordion-item">
      <h2 className="accordion-header" id="paymentMethodMasterSettings">
        <button
          className="accordion-button"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#panelsStayOpen-collapseOne"
          aria-expanded="true"
          aria-controls="panelsStayOpen-collapseOne"
        >
          <div className="col d-flex align-items-center">
            <h4 className="event-alert p-0 mb-0">
              Service Period Master Settings
            </h4>
          </div>{" "}
        </button>
      </h2>
      <div
        id="panelsStayOpen-collapseOne"
        className="accordion-collapse collapse show"
        aria-labelledby="paymentMethodMasterSettings"
      >
        <div className="">
          <div className="row mx-0">
            <div className="container px-0">
              <div className="shadowclass mt-0">
                <div className="table-responsive">
                  <table className="checklist-table remove-space inventory_table">
                    <thead>
                      <tr>
                        <th>Service Period</th>
                        <th>Cluster Name</th>
                        <th>Account Name</th>
                        <th>Master Setting</th>
                        <th>Last Push Date</th>
                        <th>Status</th>
                        <th className="action-td">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {checkArray(
                        master_setting_details?.service_periods?.master_settings
                      ) &&
                        master_setting_details?.service_periods?.master_settings.map(
                          (setting) => {
                            return (
                              <tr>
                                <td>
                                  {setting?.service_period?.period_name ?? ""}
                                </td>
                                <td>
                                  {setting?.cluster?.cluster_name
                                    ? setting?.cluster?.cluster_name
                                    : "Orphan - No Cluster"}
                                </td>
                                <td>{setting?.store_merchant?.account_name}</td>
                                <td>{msetingArr?.[setting?.setting_type]}</td>
                                <td>
                                  {changeDateFormat(
                                    setting?.push_date,
                                    "MMMM DD, yyyy"
                                  )}
                                </td>
                                <td>
                                  {" "}
                                  {setting?.status == 1 ? (
                                    <span class="green_tag"> Active </span>
                                  ) : (
                                    <span class="bordered_tag"> Inactive </span>
                                  )}
                                </td>
                                <td>
                                  <div className="d-flex justify-content-center">
                                    {getServicePeriodMasterSettingAction(setting)}{" "}
                                  </div>
                                </td>
                              </tr>
                            );
                          }
                        )}
                    </tbody>
                  </table>
                </div>
                  <div className="my-3">
                    <button
                      className="btn green-btn-revert add-plus"
                      id="addCount"
                      type="button"
                      onClick={() => closeServicePeriodMasterSettingModal(true)}
                    >
                      <i className="i-icon"> </i> Add Account Service Period
                      Type
                    </button>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModelContainer
        title={`${
          servicePeriodsMasterSettingInputForm?.id != "" ? "EDIT" : "ADD"
        }  ACCOUNT PAYMENT METHOD`}
        open={servicePeriodsMasterSettingModal}
        closeModal={closeServicePeriodMasterSettingModal}
        submitModal={servicePeriodsMasterSettingSubmit(
          submitServicePeriodMasterSettingForm
        )}
        updateModal={servicePeriodsMasterSettingSubmit(
          submitPmMasterUpdateSettingForm
        )}
        save_btn_name={"Master & Lock"}
        sec_save_btn_name={"Push & Forgot"}
        is_loading={is_servicePeriodsMasterSetting_loading}
      >
        <form
          class="validate_form"
          id="ServicePeriodTypeGeneralSettingServicePeriodForm"
          method="post"
          accept-charset="utf-8"
          novalidate="novalidate"
        >
          <fieldset class="">
            <ul class="form-list label-group new-form">
              <li>
                <label for="ServicePeriodTypeTypeName" class="required">
                  Select Service Period Type
                </label>{" "}
                <div class="input-wrap select-div">
                  <select
                    name="data[MasterSettings][service_period_id]"
                    class="required valid"
                    id="MasterSettingsServicePeriodTypeId"
                    {...servicePeriodsMasterSettingReg("service_period_id")}
                    value={
                      servicePeriodsMasterSettingInputForm?.service_period_id
                    }
                    onChange={(e) =>
                      changeServicePeriodMasterSettingInputHandler(
                        "service_period_id",
                        e?.target?.value ?? ""
                      )
                    }
                  >
                    <option value="">Select</option>
                    {checkArray(
                      master_setting_details?.service_periods?.service_period
                    ) &&
                      master_setting_details?.service_periods?.service_period.map(
                        (servicePeriod) => {
                          return (
                            <option value={servicePeriod?.id}>
                              {servicePeriod.period_name}
                            </option>
                          );
                        }
                      )}
                  </select>{" "}
                  <ErrorContainer
                    errors={servicePeriodsMasterSettingErrors}
                    name="service_period_id"
                  />
                </div>
              </li>
              <li>
                <label for="SelectAccount" class="required">
                  Select Accounts
                </label>

                <div className="checkBoxes">
                  <div className="checkbox avaiCheck flex-wrap">
                    {checkArray(
                      master_setting_details?.service_periods?.all_accounts
                    ) &&
                      master_setting_details?.service_periods?.all_accounts.map(
                        (groups) => {
                          return (
                            <Fragment key={groups?.id}>
                              <input
                                type="checkbox"
                                className="avail_checkbox"
                                value={0}
                                id={`servicePeriods_group_id_${groups?.id}`}
                                onClick={() => accountClickHandler(groups)}
                                checked={checkAccountIsClicked(groups)}
                              />
                              <label
                                for={`servicePeriods_group_id_${groups?.id}`}
                              >
                                Group - {groups?.account_name ?? ""}
                              </label>

                              <a
                                class="link"
                                role="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`.servicePeriods-account-multi-collapse-${groups?.id}`}
                                aria-expanded="false"
                                aria-controls={`servicePeriods-account-collapse-${groups?.id}`}
                              >
                                {" "}
                                <i className="btn dropdown" />{" "}
                              </a>
                              <div
                                id={`servicePeriods-account-collapse-${groups?.id}`}
                                className={`group-collapse inner-checkbox collapse servicePeriods-account-multi-collapse-${groups?.id}`}
                              >
                                {checkArray(groups?.cluster) &&
                                  groups?.cluster
                                    .filter((p) => checkArray(p.stores))
                                    .map((cluster) => {
                                      return (
                                        <div class="groupSec">
                                          <div className="checkbox avaiCheck flex-wrap">
                                            <input
                                              type="checkbox"
                                              className="avail_checkbox"
                                              value={true}
                                              id={`servicePeriods_cluster_id_${cluster?.id}`}
                                              onClick={() =>
                                                clusterClickHandler(
                                                  groups?.id,
                                                  cluster
                                                )
                                              }
                                              checked={checkClusterIsClicked(
                                                cluster
                                              )}
                                            />
                                            <label
                                              for={`servicePeriods_cluster_id_${cluster?.id}`}
                                            >
                                              Cluster -{" "}
                                              {cluster?.cluster_name ?? ""}
                                            </label>
                                            {checkArray(cluster?.stores) && (
                                              <>
                                                <a
                                                  class="link"
                                                  role="button"
                                                  data-bs-toggle="collapse"
                                                  data-bs-target={`.servicePeriods-cluster-multi-collapse-${cluster?.id}`}
                                                  aria-expanded="false"
                                                  aria-controls={`servicePeriods-cluster-collapse-${cluster?.id}`}
                                                >
                                                  {" "}
                                                  <i className="btn dropdown" />{" "}
                                                </a>
                                                <div
                                                  class={`pt-3 collapse inner-checkbox servicePeriods-cluster-multi-collapse-${cluster?.id}`}
                                                  id={`servicePeriods-cluster-collapse-${cluster?.id}`}
                                                >
                                                  {checkArray(
                                                    cluster?.stores
                                                  ) &&
                                                    cluster?.stores.map(
                                                      (store) => {
                                                        return (
                                                          <div className="checkbox avaiCheck">
                                                            <input
                                                              type="checkbox"
                                                              className="avail_checkbox"
                                                              value={true}
                                                              id={`servicePeriods_store_id_${store?.id}`}
                                                              onClick={() =>
                                                                storeClickHandler(
                                                                  groups?.id,
                                                                  store
                                                                )
                                                              }
                                                              checked={
                                                                accounts.findIndex(
                                                                  (p) =>
                                                                    p.store_merchant_id ==
                                                                    store.merchant_id
                                                                ) > -1
                                                              }
                                                            />
                                                            <label
                                                              for={`servicePeriods_store_id_${store?.id}`}
                                                            >
                                                              Store -{" "}
                                                              {store?.merchant
                                                                ?.account_name ??
                                                                ""}
                                                            </label>
                                                          </div>
                                                        );
                                                      }
                                                    )}
                                                </div>
                                              </>
                                            )}
                                          </div>
                                        </div>
                                      );
                                    })}
                              </div>
                            </Fragment>
                          );
                        }
                      )}
                  </div>
                </div>
              </li>
              <li>
                <label for="OrphanAccount" class="required">
                  <strong>Orphan</strong> - No Cluster
                </label>

                <div className="checkBoxes">
                  <div className="checkbox avaiCheck flex-wrap">
                    {checkArray(
                      master_setting_details?.service_periods?.other_accounts
                    ) &&
                      master_setting_details?.service_periods?.other_accounts.map(
                        (other_account) => {
                          return (
                            <Fragment key={other_account?.id}>
                              <input
                                type="checkbox"
                                className="avail_checkbox"
                                value={0}
                                id={`servicePeriods_other_account_id_${other_account?.id}`}
                                onClick={() =>
                                  otherAccountClickHandler(other_account)
                                }
                                checked={
                                  accounts.findIndex(
                                    (p) =>
                                      p.store_merchant_id == other_account.id
                                  ) > -1
                                }
                              />
                              <label
                                for={`servicePeriods_other_account_id_${other_account?.id}`}
                              >
                                Store - {other_account?.account_name ?? ""}
                              </label>
                            </Fragment>
                          );
                        }
                      )}
                  </div>
                </div>
              </li>
            </ul>
          </fieldset>
        </form>
      </ModelContainer>
      <ModelContainer
        title={`EDIT ACCOUNT PAYMENT METHOD`}
        open={editServicePeriodsMasterSettingModal}
        closeModal={closeEditServicePeriodMasterSettingModal}
        submitModal={editServicePeriodMasterSettingSubmit(
          submitEditServicePeriodMasterSettingForm
        )}
        updateModal={editServicePeriodMasterSettingSubmit(
          submitEditPmMasterUpdateSettingForm
        )}
        save_btn_name={"Master & Lock"}
        sec_save_btn_name={"Push & Forgot"}
        is_loading={is_editServicePeriodsMasterSetting_loading}
      >
        <form
          class="validate_form"
          id="ServicePeriodTypeGeneralSettingServicePeriodForm"
          method="post"
          accept-charset="utf-8"
          novalidate="novalidate"
        >
          {console.log(
            "editServicePeriodMasterSettingErrors:",
            editServicePeriodMasterSettingErrors
          )}
          <fieldset class="">
            <ul class="form-list label-group new-form">
              <li>
                <label for="ServicePeriodTypeTypeName" class="required">
                  Type Name
                </label>{" "}
                <div class="input-wrap select-div">
                  <select
                    name="data[MasterSettings][service_period_id]"
                    class="required valid"
                    id="MasterSettingsServicePeriodTypeId"
                    {...editServicePeriodMasterSettingReg("service_period_id")}
                    value={
                      editServicePeriodMasterSettingInputForm?.service_period_id
                    }
                    disabled
                  >
                    <option value="">Select</option>
                    {checkArray(
                      master_setting_details?.service_periods?.service_period
                    ) &&
                      master_setting_details?.service_periods?.service_period.map(
                        (servicePeriod) => {
                          return (
                            <option value={servicePeriod?.id}>
                              {servicePeriod.period_name}
                            </option>
                          );
                        }
                      )}
                  </select>{" "}
                  <ErrorContainer
                    errors={editServicePeriodMasterSettingErrors}
                    name="service_period_id"
                  />
                </div>
              </li>
              <li>
                <label for="SelectAccount" class="required">
                  Select Accounts
                </label>

                <div className="checkBoxes">
                  <div className="checkbox avaiCheck flex-wrap">
                    <input
                      type="checkbox"
                      className="avail_checkbox"
                      value={0}
                      id={`edit_servicePeriods_group_id_${selectedServicePeriodSetting?.id}`}
                      checked={true}
                      disabled={true}
                    />
                    <label
                      for={`edit_servicePeriods_group_id_${selectedServicePeriodSetting?.id}`}
                    >
                      Group -{" "}
                      {selectedServicePeriodSetting?.merchant?.account_name ??
                        ""}
                    </label>

                    <a
                      class="link"
                      role="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`.servicePeriods-account-multi-collapse-${
                        selectedServicePeriodSetting?.id ?? ""
                      }`}
                      aria-expanded="true"
                      aria-controls={`servicePeriods-account-collapse-${
                        selectedServicePeriodSetting?.id ?? ""
                      }`}
                    >
                      {" "}
                      <i className="btn dropdown" />{" "}
                    </a>
                    <div
                      id={`servicePeriods-account-collapse-${
                        selectedServicePeriodSetting?.id ?? ""
                      }`}
                      className={`group-collapse inner-checkbox servicePeriods-account-multi-collapse-${
                        selectedServicePeriodSetting?.id ?? ""
                      }`}
                    >
                      <div class="groupSec">
                        <div className="checkbox avaiCheck flex-wrap">
                          <input
                            type="checkbox"
                            className="avail_checkbox"
                            value={true}
                            id={`servicePeriods_cluster_id_${
                              selectedServicePeriodSetting?.cluster?.id ?? 0
                            }`}
                            checked={true}
                            disabled={true}
                          />
                          <label
                            for={`servicePeriods_cluster_id_${
                              selectedServicePeriodSetting?.cluster?.id ?? 0
                            }`}
                          >
                            {selectedServicePeriodSetting?.cluster?.cluster_name
                              ? `Cluster - ${selectedServicePeriodSetting?.cluster?.cluster_name}`
                              : `Orphan - No Cluster`}
                          </label>
                          <a
                            class="link"
                            role="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`.servicePeriods-cluster-multi-collapse-${selectedServicePeriodSetting?.cluster?.id}`}
                            aria-expanded="true"
                            aria-controls={`servicePeriods-cluster-collapse-${selectedServicePeriodSetting?.cluster?.id}`}
                          >
                            {" "}
                            <i className="btn dropdown" />{" "}
                          </a>
                          <div
                            class={`pt-3 inner-checkbox servicePeriods-cluster-multi-collapse-${selectedServicePeriodSetting?.cluster?.id}`}
                            id={`servicePeriods-cluster-collapse-${selectedServicePeriodSetting?.cluster?.id}`}
                          >
                            <div className="checkbox avaiCheck">
                              <input
                                type="checkbox"
                                className="avail_checkbox"
                                value={true}
                                id={`store_id_${selectedServicePeriodSetting?.store_merchant?.id}`}
                                checked={true}
                                disabled={true}
                              />
                              <label
                                for={`store_id_${selectedServicePeriodSetting?.store_merchant?.id}`}
                              >
                                Store -{" "}
                                {selectedServicePeriodSetting?.store_merchant
                                  ?.account_name ?? ""}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </fieldset>
        </form>
      </ModelContainer>
    </div>
  );
};
export default ServicePeriod;
